module.exports = __webpack_public_path__ + "static/media/regua-apoio.0cdc9def.png";